module.exports = __webpack_public_path__ + "img/info_icon.9b2f6fc0.svg";